// extracted by mini-css-extract-plugin
module.exports = {"next_image_quote":"IdeaCard_next_image_quote__Qv6IA","next_image_idea":"IdeaCard_next_image_idea__aHc5q"};